import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

export function StickyMobileCTA() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/abogados';
  // Hide on the contacto page (the page itself IS the CTA)
  const hideRoute = location.pathname === '/abogados/contacto';

  const [visible, setVisible] = useState(false);
  const [pastPricing, setPastPricing] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setVisible(window.scrollY > 400);

      if (isHome) {
        const pricingEl = document.getElementById('pricing');
        if (pricingEl) {
          const rect = pricingEl.getBoundingClientRect();
          setPastPricing(rect.top < window.innerHeight && rect.bottom > 0);
        }
      } else {
        setPastPricing(false);
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome]);

  const show = visible && !pastPricing && !hideRoute;

  const handleClick = () => {
    if (isHome) {
      document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/abogados/planes');
    }
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/10 bg-[#0F172A]/95 p-3 backdrop-blur-sm md:hidden"
        >
          <button
            type="button"
            onClick={handleClick}
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-orange-500 px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-orange-500/25"
          >
            Ver planes
            <ArrowRightIcon className="h-4 w-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
